// src/Component/NotificationManager.js
import React from 'react';
import { useNotifications } from '../hooks/useNotifications';

const NotificationManager = () => {
  const {
    isSupported,
    isEnabled,
    fcmToken,
    isLoading,
    requestPermission,
    refreshToken
  } = useNotifications();

  if (isLoading) {
    return (
      <div className="notification-manager loading">
        <p>Loading notification settings...</p>
      </div>
    );
  }

  if (!isSupported) {
    return (
      <div className="notification-manager not-supported">
        <p>Notifications are not supported in this browser.</p>
      </div>
    );
  }

  return (
    <div className="notification-manager">
      <div className="notification-status">
        <h3>Push Notifications</h3>
        <p>Status: {isEnabled ? 'Enabled' : 'Disabled'}</p>
        
        {fcmToken && (
          <div className="token-info">
            <p><strong>Device Token:</strong></p>
            <textarea 
              readOnly 
              value={fcmToken} 
              style={{
                width: '100%',
                height: '60px',
                fontSize: '12px',
                border: '1px solid #ddd',
                padding: '8px',
                borderRadius: '4px'
              }}
            />
          </div>
        )}
      </div>

      <div className="notification-actions">
        {!isEnabled && (
          <button 
            onClick={requestPermission}
            style={{
              padding: '10px 20px',
              backgroundColor: '#007bff',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              marginRight: '10px'
            }}
          >
            Enable Notifications
          </button>
        )}
        
        {isEnabled && (
          <button 
            onClick={refreshToken}
            style={{
              padding: '10px 20px',
              backgroundColor: '#28a745',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Refresh Token
          </button>
        )}
      </div>

      <div className="notification-info" style={{ marginTop: '20px', fontSize: '14px', color: '#666' }}>
        <p>
          <strong>How it works:</strong>
        </p>
        <ul>
          <li>Click "Enable Notifications" to allow push notifications</li>
          <li>Your device token will be automatically sent to the server</li>
          <li>You'll receive notifications even when the app is closed</li>
          <li>Token is automatically refreshed when needed</li>
        </ul>
      </div>
    </div>
  );
};

export default NotificationManager;
